import { render, staticRenderFns } from "./english-small-test.vue?vue&type=template&id=1d2523b0&scoped=true&"
import script from "./english-small-test.vue?vue&type=script&lang=js&"
export * from "./english-small-test.vue?vue&type=script&lang=js&"
import style0 from "./english-small-test.vue?vue&type=style&index=0&id=1d2523b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2523b0",
  null
  
)

export default component.exports